import { AtSign, Ban, Info, Lock, Mail, MessageSquare, Server, Shield, User } from 'lucide-react';
import {
  AvisosDeAjustes,
  BarraDeGuardado,
  Botonera,
  Campo,
  CargandoAjustes,
  EntradaDeContrasena,
  FalloDeAjustes,
  Resumen,
  Seccion,
  entrada,
  useAjustes,
} from './ajustes';

const SEGURIDAD = [
  { valor: 'tls', etiqueta: 'TLS', puerto: '587' },
  { valor: 'ssl', etiqueta: 'SSL', puerto: '465' },
  { valor: 'none', etiqueta: 'Ninguna', puerto: '25' },
];

export function PaginaCorreo() {
  const ajustes = useAjustes(['correo']);

  if (ajustes.cargando) {
    return <CargandoAjustes bloques={4} />;
  }
  if (ajustes.fallo) {
    return <FalloDeAjustes causa={ajustes.fallo} />;
  }

  const servidor = ajustes.texto('correo_servidor');
  const usuario = ajustes.texto('correo_usuario');
  const remitente = ajustes.texto('correo_remitente');
  const nombreRemitente = ajustes.texto('correo_remitente_nombre');
  const respuesta = ajustes.texto('correo_respuesta');
  const seguridad = ajustes.texto('correo_seguridad') || 'tls';
  const puerto = ajustes.texto('correo_puerto');
  const hayClave = ajustes.meta('correo_clave')?.tieneValor ?? false;

  return (
    <div className="grid gap-6">
      <AvisosDeAjustes ajustes={ajustes} />

      <Seccion icono={Server} color="azul" titulo="Servidor SMTP">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <Campo etiqueta="Servidor" icono={Server} ancho="sm:col-span-2">
            <input
              value={servidor}
              onChange={(e) => ajustes.editar('correo_servidor', e.target.value)}
              placeholder="smtp.gmail.com"
              className={`${entrada} pl-10`}
            />
          </Campo>

          <Campo etiqueta="Puerto">
            <input
              type="number"
              value={puerto}
              onChange={(e) => ajustes.editar('correo_puerto', e.target.value)}
              placeholder="587"
              className={`${entrada} importe text-center text-base`}
            />
          </Campo>

          <Campo etiqueta="Seguridad" ayuda="Cambiarla ajusta el puerto que le corresponde">
            <Botonera
              valor={seguridad}
              opciones={SEGURIDAD}

              alElegir={(v) => {
                ajustes.editar('correo_seguridad', v);
                const opcion = SEGURIDAD.find((o) => o.valor === v);
                if (opcion) {
                  ajustes.editar('correo_puerto', opcion.puerto);
                }
              }}
            />
          </Campo>
        </div>

        <div className="mt-4 grid gap-4 sm:grid-cols-2">
          <Campo etiqueta="Usuario" icono={User}>
            <input
              value={usuario}
              onChange={(e) => ajustes.editar('correo_usuario', e.target.value)}
              placeholder="facturacion@epagal.gob.ec"
              className={`${entrada} pl-10`}
            />
          </Campo>

          <Campo
            etiqueta="Contraseña"
            icono={Lock}
            ayuda={
              hayClave
                ? 'Hay una guardada · déjela vacía para no cambiarla'
                : 'Se guarda cifrada en la base de datos'
            }
          >
            <EntradaDeContrasena ajustes={ajustes} clave="correo_clave" />
          </Campo>
        </div>
      </Seccion>

      <Seccion icono={AtSign} color="marca" titulo="Datos del remitente">
        <div className="grid gap-4 sm:grid-cols-2">
          <Campo etiqueta="Nombre del remitente" icono={MessageSquare}>
            <input
              value={nombreRemitente}
              onChange={(e) => ajustes.editar('correo_remitente_nombre', e.target.value)}
              placeholder="EPAGAL EP · Facturación"
              className={`${entrada} pl-10`}
            />
          </Campo>

          <Campo etiqueta="Correo del remitente" icono={Mail}>
            <input
              type="email"
              value={remitente}
              onChange={(e) => ajustes.editar('correo_remitente', e.target.value)}
              placeholder="facturacion@epagal.gob.ec"
              className={`${entrada} pl-10`}
            />
          </Campo>

          <Campo
            etiqueta="Correo de respuesta"
            icono={Mail}
            ancho="sm:col-span-2"
            ayuda="A donde llega la contestación si el cliente responde el comprobante"
          >
            <input
              type="email"
              value={respuesta}
              onChange={(e) => ajustes.editar('correo_respuesta', e.target.value)}
              placeholder="soporte@epagal.gob.ec"
              className={`${entrada} pl-10`}
            />
          </Campo>
        </div>
      </Seccion>

      <Seccion icono={Ban} color="rojo" titulo="Correos excluidos">
        <Campo
          etiqueta="Correos que no deben recibir comprobantes"
          icono={Ban}
          ayuda="Separados por coma. Los clientes sin correo real llevan una dirección interna de la propia empresa: mandarles comprobantes llenaría ese buzón con las facturas de todos ellos."
        >
          <input
            value={ajustes.texto('correo_excluidos')}
            onChange={(e) => ajustes.editar('correo_excluidos', e.target.value)}
            placeholder="atencionepagal@gmail.com, sinmail@epagal.gob.ec"
            className={`${entrada} pl-10`}
          />
        </Campo>
      </Seccion>

      <Seccion icono={Shield} color="marca" titulo="Estado de la configuración">
        <Resumen
          puntos={[
            { etiqueta: 'Servidor', valor: servidor || 'Sin configurar', listo: Boolean(servidor) },
            {
              etiqueta: 'Puerto',
              valor: puerto ? `${puerto} · ${seguridad.toUpperCase()}` : 'Sin configurar',
              listo: Boolean(puerto),
            },
            { etiqueta: 'Usuario', valor: usuario || 'Sin configurar', listo: Boolean(usuario) },
            {
              etiqueta: 'Contraseña',
              valor: hayClave ? 'Guardada' : 'Sin configurar',
              listo: hayClave,
            },
            {
              etiqueta: 'Remitente',
              valor: remitente || 'Sin configurar',
              listo: Boolean(remitente),
            },
            {
              etiqueta: 'Correo de respuesta',
              valor: respuesta || 'Sin configurar',
              listo: Boolean(respuesta),
            },
          ]}
        />
      </Seccion>

      <div className="flex gap-3 rounded-xl border border-blue-200 bg-blue-50 p-4">
        <Info className="mt-0.5 size-4 shrink-0 text-blue-600" aria-hidden />
        <div className="text-xs uppercase text-blue-800">
          <p className="font-semibold uppercase">Si el servidor es Gmail</p>
          <p className="mt-1">
            No sirve la contraseña de la cuenta: hay que generar una <b>contraseña de aplicación</b>{' '}
            en la configuración de Google (Seguridad → Verificación en dos pasos → Contraseñas de
            aplicaciones) y usar esa aquí.
          </p>
          <p className="mt-2 text-blue-700">
            El envío de prueba llega con la facturación electrónica, que es lo que usa este
            servidor.
          </p>
        </div>
      </div>

      <BarraDeGuardado ajustes={ajustes} />
    </div>
  );
}
